// Material UI
import { makeStyles } from '@material-ui/core/styles'
// Consts
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  actionContainer: {},
  buttonsContainer: {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: '32px',
  },
  menuContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
    gap: 8,
  },

  itemDetailsContainer: {
    color: Colors.SECONDARY_FONT_COLOR,
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'pre-wrap',
  },
  itemName: {
    minWidth: 160,
  },
  itemDeactivationOptionsContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 16,
    position: 'relative',
    borderRadius: 8,
    border: '1px solid #EDEDED',
  },
  itemDeactivationOptionDescription: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 24,
  },
  itemDeactivationOptionTitle: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 20,
  },
  itemInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 16,
    width: '100%',
  },
  palette: {
    primary: Colors.PRIMARY_COLOR,
  },
  radioButton: {
    margin: '8px 0px 0px 16px',
    '&:active, &:focus': {
      borderColor: Colors.PRIMARY_COLOR,
    },
  },
  root: {
    alignItems: 'center',
    color: Colors.PRIMARY_FONT_COLOR,
    display: 'flex',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    minHeight: 60,
    width: '100%',
  },
}))
